import Image from 'next/image';
import styled from 'styled-components';

import FacebookMarketingSvg from '../../assets/icons/FacebookMarketingSvg';
import LinkedInMarketingSvg from '../../assets/icons/LinkedInMarketingSvg';
import XSvg from '../../assets/icons/XSvg';
import YoutubeMarketingSvg from '../../assets/icons/YoutubeMarketingSvg';
import theme from '../../assets/theme';
import { IconWrapper } from '../_atoms/IconWrapper';

export const ColumnContainer = styled.div`
  width: 100%;
`;

export const FourSocials = () => {
  return (
    <TwoColumns>
      <SocialLink>
        <IconWrapper height="50px" width="50px">
          <XSvg />
        </IconWrapper>
        <a href="https://twitter.com/curipodofficial">@curipodofficial</a>
      </SocialLink>
      <SocialLink>
        <IconWrapper height="50px" width="50px">
          <LinkedInMarketingSvg />
        </IconWrapper>
        <a href="www.linkedin.com/company/curipod">www.linkedin.com/company/curipod</a>
      </SocialLink>
      <SocialLink>
        <IconWrapper height="50px" width="50px">
          <YoutubeMarketingSvg />
        </IconWrapper>
        <a href="https://www.youtube.com/@curipod163">@curipod163</a>
      </SocialLink>
      <SocialLink>
        <IconWrapper height="50px" width="50px">
          <FacebookMarketingSvg />
        </IconWrapper>
        <a href="https://www.facebook.com/groups/629277211454616">
          https://www.facebook.com/groups/629277211454616
        </a>
      </SocialLink>
    </TwoColumns>
  );
};

const SocialLink = styled.div`
  display: flex;
  align-items: center;
  & > *:not(:first-child) {
    margin-left: 10px;
  }

  a {
    color: ${theme.colors.black};
    font-weight: bold;
  }
`;

export const PersonSection = ({
  content,
  imageSrc,
  name,
  role,
  title,
}: {
  name: string;
  role: string;
  imageSrc: string;
  content: React.ReactNode;
  title: string;
}) => {
  return (
    <PersonContainer>
      <h3>{title}</h3>
      <PersonalInfo>
        <Image style={{ flex: '0 1 150px' }} width={150} height={150} src={imageSrc} />
        <div style={{ flex: 1 }}>
          <p>{name}</p>
          <p>{role}</p>
        </div>
      </PersonalInfo>
      <p>{content}</p>
    </PersonContainer>
  );
};
const PersonalInfo = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  font-weight: bold;

  & h3,
  p {
    font-weight: bold;
  }
`;

const PersonContainer = styled.div`
  width: 100%;
  &&& h3 {
    font-size: 30px;
    margin-bottom: 10px;
  }
  & p {
    margin-bottom: 2px;
  }

  & span {
    font-weight: normal;
  }
`;

const TwoColumns = ({ children }: { children: React.ReactNode }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px 20px;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

export default TwoColumns;
